import { createContext } from 'react';

import { useAuthContext } from '@cognite/e2e-auth';
import { useQueryClient } from '@tanstack/react-query';

import { useCdmSelectedLocationContext } from './../../selected-location-provider/cdm-selected-location-context';
import { createOfflineDataStore } from './../offline-data-store';

export interface UseOfflineStoreContextInterface {
  useAuthContext: () => {
    client: Pick<
      ReturnType<typeof useAuthContext>['client'],
      'getBaseUrl' | 'project'
    >;
    authState: {
      user: Pick<
        ReturnType<typeof useAuthContext>['authState']['user'],
        'cdfId'
      >;
    };
  };
  useQueryClient: typeof useQueryClient;
  useCdmSelectedLocationContext: typeof useCdmSelectedLocationContext;
  createOfflineDataStore: typeof createOfflineDataStore;
}

export const UseOfflineStoreContext =
  createContext<UseOfflineStoreContextInterface>({
    useAuthContext,
    useQueryClient,
    useCdmSelectedLocationContext,
    createOfflineDataStore,
  });
